import { createComponent, ComponentProps } from '@/internals/utils';
export type CardHeaderProps = ComponentProps;

const CardHeader = createComponent({ name: 'CardHeader', componentAs: 'div' });

export default CardHeader;
